import { RefObject, useEffect } from "react";

export function useOutsideClickEvent(
	ref: RefObject<HTMLElement>,
	outSideClickCallback: any,
) {
	/**
	 * Alert if clicked on outside of element
	 */
	function handleClickOutside(event: any) {
		if (event) {
			if (ref.current && !ref.current.contains(event.target)) {
				outSideClickCallback();
			}
		}
	}

	useEffect(() => {
		// Bind the event listener
		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			// Unbind the event listener on clean up
			document.removeEventListener("mousedown", handleClickOutside);
		};
	});
}
